export function getdata(){
	var obj = {
			headData:[
				{
					title: "项目及栏次",
					prop: "title",
					width:"105px",
					custom:true,
					fixed:'left',
				},
				{
					title: "项目2",
					prop: "mintitle",
					width:"140px",
					custom:true,
					fixed:'left',
				},
				{
					title: "项目3",
					prop: "zzs_1_x_0",
					width:"220px",
					custom:true,
					fixed:'left',
				},
				{
					title: "栏次",
					prop: "grade",
					width:"70px",
					custom:true
				},
				{
					title:"开具增值税专用发票",
					prop: "",
					children:[
						{
						title: "销售额",
						
						prop: "",
						children:[
							{
							title: "1",
							
							prop: "zzs_1_x_1",
							custom:true,
							width:"100px",
							},
						]
						},
						{
						title: "销项(应纳)税额",
						prop: "",
						
						children:[
							{
							title: "2",
							prop: "zzs_1_x_2",
							custom:true,
							
							width:"110px",
							},
						]
						}
					]
				},
				{
					title: "开具其他发票",
					prop: "",
					children:[
						{
						title: "销售额",
						
						prop: "",
						children:[
							{
							title: "3",
							prop: "zzs_1_x_3",
							custom:true,
							
							width:"110px",
							},
						]
						},
						{
						title: "销项(应纳)税额",
						prop: "",
						
						children:[
							{
							title: "4",
							prop: "zzs_1_x_4",
							custom:true,
							
							width:"110px",
							},
						]
						}
					]
				},
				{
					title: "未开具发票",
					prop: "",
					children:[
						{
						title: "销售额",
						prop: "",
						
						children:[
							{
							title: "5",
							
							prop: "zzs_1_x_5",
							custom:true,
							width:"110px",
							},
						]
						},
						{
						title: "销项(应纳)税额",
						prop: "",
						
						children:[
							{
								
							title: "6",
							prop: "zzs_1_x_6",
							custom:true,
							width:"110px",
							},
						]
						}
					]
				},
				{
					title: "纳税检查调整",
					prop: "",
					children:[
						{
						title: "销售额",
						prop: "",
						
						children:[
							{
							title: "7",
							
							prop: "zzs_1_x_7",
							custom:true,
							width:"110px",
							},
						]
						},
						{
						title: "销项(应纳)税额",
						prop: "",
						
						children:[
							{
							title: "8",
							
							prop: "zzs_1_x_8",
							custom:true,
							width:"110px",
							},
						]
						}
					]
				},
				{
					title: "合计",
					prop: "",
					children:[
						{
						title: "销售额",
						prop: "",
						
						children:[
							{
								
							title: "9=1+3+5+7",
							prop: "zzs_1_x_9",
							custom:true,
							width:"110px",
							},
						]
						},
						{
						title: "销项(应纳)税额",
						prop: "",
						
						children:[
							{
							title: "10=2+4+6+8",
							
							prop: "zzs_1_x_10",
							custom:true,
							width:"110px",
							},
						]
						},
						{
						title: "价税合计",
						
						prop: "",
						children:[
							{
							title: "11=9+10",
							prop: "zzs_1_x_11",
							
							custom:true,
							width:"110px",
							},
						]
						}
					]
				},
				{
					title: "服务、不动产和无形资产扣除项目本期实际扣除金额",
					prop: "",
					children:[
						{
						title: "",
						prop: "",
						children:[
							{
							title: "12",
							
							prop: "zzs_1_x_12",
							custom:true,
							width:"110px",
							
							},
						]
						},
					]
				},
				{
					title: "扣除后",
					prop: "",
					children:[
						{
						title: "含税(免税)销售额",
						prop: "",
						
						children:[
							{
								
							title: "13=11-12",
							prop: "zzs_1_x_13",
							custom:true,
							width:"110px",
							},
						]
						},
						{
						title: "销项(应纳)税额",
						prop: "",
						
						children:[
							{
							title: "14=13列/（100%+税率或征收率）*税率或征收率",
							
							prop: "zzs_1_x_14",
							custom:true,
							width:"110px",
							},
						]
						}
					]
				},
			],
			tableData:[
				{
					title:"一、一般计税方法计税",
					mintitle:"全部征税项目",
					coloum:"13%税率的货物及加工修理修配劳务",
					grade:"1",
					disabledzzs_1_x_9:true,//禁止合计销售额填写
					disabledzzs_1_x_10:true,//禁止合计销项（应纳）税额
					disabledzzs_1_x_11:true,//禁止合计价税合计
					disabledzzs_1_x_12:true,//禁止各类服务金额
					disabledzzs_1_x_13:true, 
					disabledzzs_1_x_14:true,
					zzs_1_x_1:{
						cellVal:""
					},
					zzs_1_x_2:{
						cellVal:""
					},
					zzs_1_x_3:{
						cellVal:""
					},
					zzs_1_x_4:{
						cellVal:""
					},
					zzs_1_x_5:{
						cellVal:""
					},
					zzs_1_x_6:{
						cellVal:""
					},
					zzs_1_x_7:{
						cellVal:""
					},
					zzs_1_x_8:{
						cellVal:""
					},
					zzs_1_x_9:{
						cellVal:""
					},
					zzs_1_x_10:{
						cellVal:""
					},
					zzs_1_x_11:{
						cellVal:""
					},
					zzs_1_x_12:{
						cellVal:""
					},
					zzs_1_x_13:{
						cellVal:""
					},
					zzs_1_x_14:{
						cellVal:""
					},
				},
				{
					title:"一、一般计税方法计税",
					mintitle:"全部征税项目",
					coloum:"13%税率的服务、不动产和无形资产",
					grade:"2",
					disabledzzs_1_x_9:true,//禁止合计销售额填写
					disabledzzs_1_x_10:true,//禁止合计销项（应纳）税额
					disabledzzs_1_x_11:true,//禁止合计价税合计
					disabledzzs_1_x_12:true,//禁止各类服务金额
					disabledzzs_1_x_13:true,
					disabledzzs_1_x_14:true,
					zzs_1_x_1:{
						cellVal:""
					},
					zzs_1_x_2:{
						cellVal:""
					},
					zzs_1_x_3:{
						cellVal:""
					},
					zzs_1_x_4:{
						cellVal:""
					},
					zzs_1_x_5:{
						cellVal:""
					},
					zzs_1_x_6:{
						cellVal:""
					},
					zzs_1_x_7:{
						cellVal:""
					},
					zzs_1_x_8:{
						cellVal:""
					},
					zzs_1_x_9:{
						cellVal:""
					},
					zzs_1_x_10:{
						cellVal:""
					},
					zzs_1_x_11:{
						cellVal:""
					},
					zzs_1_x_12:{
						cellVal:""
					},
					zzs_1_x_13:{
						cellVal:""
					},
					zzs_1_x_14:{
						cellVal:""
					},
				},
				{
					title:"一、一般计税方法计税",
					mintitle:"全部征税项目",
					coloum:"9%税率的货物及加工修理修配劳务",
					grade:"3",
					disabledzzs_1_x_9:true,//禁止合计销售额填写
					disabledzzs_1_x_10:true,//禁止合计销项（应纳）税额
					disabledzzs_1_x_11:true,//禁止合计价税合计
					disabledzzs_1_x_12:true,//禁止各类服务金额
					disabledzzs_1_x_13:true,
					disabledzzs_1_x_14:true,
					zzs_1_x_1:{
						cellVal:""
					},
					zzs_1_x_2:{
						cellVal:""
					},
					zzs_1_x_3:{
						cellVal:""
					},
					zzs_1_x_4:{
						cellVal:""
					},
					zzs_1_x_5:{
						cellVal:""
					},
					zzs_1_x_6:{
						cellVal:""
					},
					zzs_1_x_7:{
						cellVal:""
					},
					zzs_1_x_8:{
						cellVal:""
					},
					zzs_1_x_9:{
						cellVal:""
					},
					zzs_1_x_10:{
						cellVal:""
					},
					zzs_1_x_11:{
						cellVal:""
					},
					zzs_1_x_12:{
						cellVal:""
					},
					zzs_1_x_13:{
						cellVal:""
					},
					zzs_1_x_14:{
						cellVal:""
					},
				},
				{
					title:"一、一般计税方法计税",
					mintitle:"全部征税项目",
					coloum:"9%税率的服务、不动产和无形资产",
					grade:"4",
					disabledzzs_1_x_9:true,//禁止合计销售额填写
					disabledzzs_1_x_10:true,//禁止合计销项（应纳）税额
					disabledzzs_1_x_11:true,//禁止合计价税合计
					disabledzzs_1_x_12:true,//禁止各类服务金额
					disabledzzs_1_x_13:true,
					disabledzzs_1_x_14:true,
					zzs_1_x_1:{
						cellVal:""
					},
					zzs_1_x_2:{
						cellVal:""
					},
					zzs_1_x_3:{
						cellVal:""
					},
					zzs_1_x_4:{
						cellVal:""
					},
					zzs_1_x_5:{
						cellVal:""
					},
					zzs_1_x_6:{
						cellVal:""
					},
					zzs_1_x_7:{
						cellVal:""
					},
					zzs_1_x_8:{
						cellVal:""
					},
					zzs_1_x_9:{
						cellVal:""
					},
					zzs_1_x_10:{
						cellVal:""
					},
					zzs_1_x_11:{
						cellVal:""
					},
					zzs_1_x_12:{
						cellVal:""
					},
					zzs_1_x_13:{
						cellVal:""
					},
					zzs_1_x_14:{
						cellVal:""
					},
				},
				{
					title:"一、一般计税方法计税",
					mintitle:"全部征税项目",
					coloum:"6%税率",
					grade:"5",
					disabledzzs_1_x_9:true,//禁止合计销售额填写
					disabledzzs_1_x_10:true,//禁止合计销项（应纳）税额
					disabledzzs_1_x_11:true,//禁止合计价税合计
					disabledzzs_1_x_12:true,//禁止各类服务金额
					disabledzzs_1_x_13:true,
					disabledzzs_1_x_14:true,
					zzs_1_x_1:{
						cellVal:""
					},
					zzs_1_x_2:{
						cellVal:""
					},
					zzs_1_x_3:{
						cellVal:""
					},
					zzs_1_x_4:{
						cellVal:""
					},
					zzs_1_x_5:{
						cellVal:""
					},
					zzs_1_x_6:{
						cellVal:""
					},
					zzs_1_x_7:{
						cellVal:""
					},
					zzs_1_x_8:{
						cellVal:""
					},
					zzs_1_x_9:{
						cellVal:""
					},
					zzs_1_x_10:{
						cellVal:""
					},
					zzs_1_x_11:{
						cellVal:""
					},
					zzs_1_x_12:{
						cellVal:""
					},
					zzs_1_x_13:{
						cellVal:""
					},
					zzs_1_x_14:{
						cellVal:""
					},
				},
				{
					title:"一、一般计税方法计税",
					mintitle:"其中：即征即退项目",
					coloum:"即征即退货物及加工修理修配劳务",
					grade:"6",
					disabledzzs_1_x_1:true,
					disabledzzs_1_x_2:true,
					disabledzzs_1_x_3:true,
					disabledzzs_1_x_4:true,
					disabledzzs_1_x_5:true,
					disabledzzs_1_x_6:true,
					disabledzzs_1_x_7:true,
					disabledzzs_1_x_8:true,
					disabledzzs_1_x_11:true,//禁止合计价税合计
					disabledzzs_1_x_12:true,//禁止各类服务金额
					disabledzzs_1_x_13:true,
					disabledzzs_1_x_14:true,
					zzs_1_x_1:{
						cellVal:""
					},
					zzs_1_x_2:{
						cellVal:""
					},
					zzs_1_x_3:{
						cellVal:""
					},
					zzs_1_x_4:{
						cellVal:""
					},
					zzs_1_x_5:{
						cellVal:""
					},
					zzs_1_x_6:{
						cellVal:""
					},
					zzs_1_x_7:{
						cellVal:""
					},
					zzs_1_x_8:{
						cellVal:""
					},
					zzs_1_x_9:{
						cellVal:""
					},
					zzs_1_x_10:{
						cellVal:""
					},
					zzs_1_x_11:{
						cellVal:""
					},
					zzs_1_x_12:{
						cellVal:""
					},
					zzs_1_x_13:{
						cellVal:""
					},
					zzs_1_x_14:{
						cellVal:""
					},
				},
				{
					title:"一、一般计税方法计税",
					mintitle:"其中：即征即退项目",
					coloum:"即征即退服务、不动产和无形资产",
					grade:"7",
					disabledzzs_1_x_1:true,
					disabledzzs_1_x_2:true,
					disabledzzs_1_x_3:true,
					disabledzzs_1_x_4:true,
					disabledzzs_1_x_5:true,
					disabledzzs_1_x_6:true,
					disabledzzs_1_x_7:true,
					disabledzzs_1_x_8:true,
					disabledzzs_1_x_11:true,//禁止合计价税合计
					disabledzzs_1_x_12:true,//禁止各类服务金额
					disabledzzs_1_x_13:true,
					zzs_1_x_1:{
						cellVal:""
					},
					zzs_1_x_2:{
						cellVal:""
					},
					zzs_1_x_3:{
						cellVal:""
					},
					zzs_1_x_4:{
						cellVal:""
					},
					zzs_1_x_5:{
						cellVal:""
					},
					zzs_1_x_6:{
						cellVal:""
					},
					zzs_1_x_7:{
						cellVal:""
					},
					zzs_1_x_8:{
						cellVal:""
					},
					zzs_1_x_9:{
						cellVal:""
					},
					zzs_1_x_10:{
						cellVal:""
					},
					zzs_1_x_11:{
						cellVal:""
					},
					zzs_1_x_12:{
						cellVal:""
					},
					zzs_1_x_13:{
						cellVal:""
					},
					zzs_1_x_14:{
						cellVal:""
					},
				},
				{
					title:"二、简易计税方法计税",
					mintitle:"全部征税项目",
					coloum:"6%征收率",
					grade:"8",
					disabledzzs_1_x_7:true,
					disabledzzs_1_x_8:true,
					disabledzzs_1_x_9:true,//禁止合计销售额填写
					disabledzzs_1_x_10:true,//禁止合计销项（应纳）税额
					disabledzzs_1_x_11:true,//禁止合计价税合计
					disabledzzs_1_x_12:true,//禁止各类服务金额
					disabledzzs_1_x_13:true,
					disabledzzs_1_x_14:true,
					zzs_1_x_1:{
						cellVal:""
					},
					zzs_1_x_2:{
						cellVal:""
					},
					zzs_1_x_3:{
						cellVal:""
					},
					zzs_1_x_4:{
						cellVal:""
					},
					zzs_1_x_5:{
						cellVal:""
					},
					zzs_1_x_6:{
						cellVal:""
					},
					zzs_1_x_7:{
						cellVal:""
					},
					zzs_1_x_8:{
						cellVal:""
					},
					zzs_1_x_9:{
						cellVal:""
					},
					zzs_1_x_10:{
						cellVal:""
					},
					zzs_1_x_11:{
						cellVal:""
					},
					zzs_1_x_12:{
						cellVal:""
					},
					zzs_1_x_13:{
						cellVal:""
					},
					zzs_1_x_14:{
						cellVal:""
					},
				},
				{
					title:"二、简易计税方法计税",
					mintitle:"全部征税项目",
					coloum:"5%征收率的货物及加工修理修配劳务",
					grade:"9a",
					disabledzzs_1_x_7:true,
					disabledzzs_1_x_8:true,
					disabledzzs_1_x_9:true,//禁止合计销售额填写
					disabledzzs_1_x_10:true,//禁止合计销项（应纳）税额
					disabledzzs_1_x_11:true,//禁止合计价税合计
					disabledzzs_1_x_12:true,//禁止各类服务金额
					disabledzzs_1_x_13:true,
					disabledzzs_1_x_14:true,
					zzs_1_x_1:{
						cellVal:""
					},
					zzs_1_x_2:{
						cellVal:""
					},
					zzs_1_x_3:{
						cellVal:""
					},
					zzs_1_x_4:{
						cellVal:""
					},
					zzs_1_x_5:{
						cellVal:""
					},
					zzs_1_x_6:{
						cellVal:""
					},
					zzs_1_x_7:{
						cellVal:""
					},
					zzs_1_x_8:{
						cellVal:""
					},
					zzs_1_x_9:{
						cellVal:""
					},
					zzs_1_x_10:{
						cellVal:""
					},
					zzs_1_x_11:{
						cellVal:""
					},
					zzs_1_x_12:{
						cellVal:""
					},
					zzs_1_x_13:{
						cellVal:""
					},
					zzs_1_x_14:{
						cellVal:""
					},
				},
				{
					title:"二、简易计税方法计税",
					mintitle:"全部征税项目",
					coloum:"5%征收率的服务、不动产和无形资产",
					grade:"9b",
					disabledzzs_1_x_7:true,
					disabledzzs_1_x_8:true,
					disabledzzs_1_x_9:true,//禁止合计销售额填写
					disabledzzs_1_x_10:true,//禁止合计销项（应纳）税额
					disabledzzs_1_x_11:true,//禁止合计价税合计
					disabledzzs_1_x_12:true,//禁止各类服务金额
					disabledzzs_1_x_13:true,
					disabledzzs_1_x_14:true,
					zzs_1_x_1:{
						cellVal:""
					},
					zzs_1_x_2:{
						cellVal:""
					},
					zzs_1_x_3:{
						cellVal:""
					},
					zzs_1_x_4:{
						cellVal:""
					},
					zzs_1_x_5:{
						cellVal:""
					},
					zzs_1_x_6:{
						cellVal:""
					},
					zzs_1_x_7:{
						cellVal:""
					},
					zzs_1_x_8:{
						cellVal:""
					},
					zzs_1_x_9:{
						cellVal:""
					},
					zzs_1_x_10:{
						cellVal:""
					},
					zzs_1_x_11:{
						cellVal:""
					},
					zzs_1_x_12:{
						cellVal:""
					},
					zzs_1_x_13:{
						cellVal:""
					},
					zzs_1_x_14:{
						cellVal:""
					},
				},
				{
					title:"二、简易计税方法计税",
					mintitle:"全部征税项目",
					coloum:"4%征收率",
					grade:"10",
					disabledzzs_1_x_7:true,
					disabledzzs_1_x_8:true,
					disabledzzs_1_x_9:true,//禁止合计销售额填写
					disabledzzs_1_x_10:true,//禁止合计销项（应纳）税额
					disabledzzs_1_x_11:true,//禁止合计价税合计
					disabledzzs_1_x_12:true,//禁止各类服务金额
					disabledzzs_1_x_13:true,
					disabledzzs_1_x_14:true,
					zzs_1_x_1:{
						cellVal:""
					},
					zzs_1_x_2:{
						cellVal:""
					},
					zzs_1_x_3:{
						cellVal:""
					},
					zzs_1_x_4:{
						cellVal:""
					},
					zzs_1_x_5:{
						cellVal:""
					},
					zzs_1_x_6:{
						cellVal:""
					},
					zzs_1_x_7:{
						cellVal:""
					},
					zzs_1_x_8:{
						cellVal:""
					},
					zzs_1_x_9:{
						cellVal:""
					},
					zzs_1_x_10:{
						cellVal:""
					},
					zzs_1_x_11:{
						cellVal:""
					},
					zzs_1_x_12:{
						cellVal:""
					},
					zzs_1_x_13:{
						cellVal:""
					},
					zzs_1_x_14:{
						cellVal:""
					},
				},
				{
					title:"二、简易计税方法计税",
					mintitle:"全部征税项目",
					coloum:"3%征收率的货物及加工修理修配劳务",
					grade:"11",
					disabledzzs_1_x_7:true,
					disabledzzs_1_x_8:true,
					disabledzzs_1_x_9:true,//禁止合计销售额填写
					disabledzzs_1_x_10:true,//禁止合计销项（应纳）税额
					disabledzzs_1_x_11:true,//禁止合计价税合计
					disabledzzs_1_x_12:true,//禁止各类服务金额
					disabledzzs_1_x_13:true,
					disabledzzs_1_x_14:true,
					zzs_1_x_1:{
						cellVal:""
					},
					zzs_1_x_2:{
						cellVal:""
					},
					zzs_1_x_3:{
						cellVal:""
					},
					zzs_1_x_4:{
						cellVal:""
					},
					zzs_1_x_5:{
						cellVal:""
					},
					zzs_1_x_6:{
						cellVal:""
					},
					zzs_1_x_7:{
						cellVal:""
					},
					zzs_1_x_8:{
						cellVal:""
					},
					zzs_1_x_9:{
						cellVal:""
					},
					zzs_1_x_10:{
						cellVal:""
					},
					zzs_1_x_11:{
						cellVal:""
					},
					zzs_1_x_12:{
						cellVal:""
					},
					zzs_1_x_13:{
						cellVal:""
					},
					zzs_1_x_14:{
						cellVal:""
					},
				},
				{
					title:"二、简易计税方法计税",
					mintitle:"全部征税项目",
					coloum:"3%征收率的服务、不动产和无形资产",
					grade:"12",
					disabledzzs_1_x_7:true,
					disabledzzs_1_x_8:true,
					disabledzzs_1_x_9:true,//禁止合计销售额填写
					disabledzzs_1_x_10:true,//禁止合计销项（应纳）税额
					disabledzzs_1_x_11:true,//禁止合计价税合计
					disabledzzs_1_x_12:true,//禁止各类服务金额
					disabledzzs_1_x_13:true,
					disabledzzs_1_x_14:true,
					zzs_1_x_1:{
						cellVal:""
					},
					zzs_1_x_2:{
						cellVal:""
					},
					zzs_1_x_3:{
						cellVal:""
					},
					zzs_1_x_4:{
						cellVal:""
					},
					zzs_1_x_5:{
						cellVal:""
					},
					zzs_1_x_6:{
						cellVal:""
					},
					zzs_1_x_7:{
						cellVal:""
					},
					zzs_1_x_8:{
						cellVal:""
					},
					zzs_1_x_9:{
						cellVal:""
					},
					zzs_1_x_10:{
						cellVal:""
					},
					zzs_1_x_11:{
						cellVal:""
					},
					zzs_1_x_12:{
						cellVal:""
					},
					zzs_1_x_13:{
						cellVal:""
					},
					zzs_1_x_14:{
						cellVal:""
					},
				},
				{
					title:"二、简易计税方法计税",
					mintitle:"全部征税项目",
					coloum:"预征率   %",
					grade:"13a",
					disabledzzs_1_x_7:true,
					disabledzzs_1_x_8:true,
					disabledzzs_1_x_9:true,//禁止合计销售额填写
					disabledzzs_1_x_10:true,//禁止合计销项（应纳）税额
					disabledzzs_1_x_11:true,//禁止合计价税合计
					disabledzzs_1_x_12:true,//禁止各类服务金额
					disabledzzs_1_x_13:true,
					disabledzzs_1_x_14:true,
					zzs_1_x_1:{
						cellVal:""
					},
					zzs_1_x_2:{
						cellVal:""
					},
					zzs_1_x_3:{
						cellVal:""
					},
					zzs_1_x_4:{
						cellVal:""
					},
					zzs_1_x_5:{
						cellVal:""
					},
					zzs_1_x_6:{
						cellVal:""
					},
					zzs_1_x_7:{
						cellVal:""
					},
					zzs_1_x_8:{
						cellVal:""
					},
					zzs_1_x_9:{
						cellVal:""
					},
					zzs_1_x_10:{
						cellVal:""
					},
					zzs_1_x_11:{
						cellVal:""
					},
					zzs_1_x_12:{
						cellVal:""
					},
					zzs_1_x_13:{
						cellVal:""
					},
					zzs_1_x_14:{
						cellVal:""
					},
				},
				{
					title:"二、简易计税方法计税",
					mintitle:"全部征税项目",
					coloum:"预征率   %",
					grade:"13b",
					disabledzzs_1_x_7:true,
					disabledzzs_1_x_8:true,
					disabledzzs_1_x_9:true,//禁止合计销售额填写
					disabledzzs_1_x_10:true,//禁止合计销项（应纳）税额
					disabledzzs_1_x_11:true,//禁止合计价税合计
					disabledzzs_1_x_12:true,//禁止各类服务金额
					disabledzzs_1_x_13:true,
					disabledzzs_1_x_14:true,
					zzs_1_x_1:{
						cellVal:""
					},
					zzs_1_x_2:{
						cellVal:""
					},
					zzs_1_x_3:{
						cellVal:""
					},
					zzs_1_x_4:{
						cellVal:""
					},
					zzs_1_x_5:{
						cellVal:""
					},
					zzs_1_x_6:{
						cellVal:""
					},
					zzs_1_x_7:{
						cellVal:""
					},
					zzs_1_x_8:{
						cellVal:""
					},
					zzs_1_x_9:{
						cellVal:""
					},
					zzs_1_x_10:{
						cellVal:""
					},
					zzs_1_x_11:{
						cellVal:""
					},
					zzs_1_x_12:{
						cellVal:""
					},
					zzs_1_x_13:{
						cellVal:""
					},
					zzs_1_x_14:{
						cellVal:""
					},
				},
				{
					title:"二、简易计税方法计税",
					mintitle:"全部征税项目",
					coloum:"预征率   %",
					grade:"13c",
					disabledzzs_1_x_7:true,
					disabledzzs_1_x_8:true,
					disabledzzs_1_x_9:true,//禁止合计销售额填写
					disabledzzs_1_x_10:true,//禁止合计销项（应纳）税额
					disabledzzs_1_x_11:true,//禁止合计价税合计
					disabledzzs_1_x_12:true,//禁止各类服务金额
					disabledzzs_1_x_13:true,
					disabledzzs_1_x_14:true,
					zzs_1_x_1:{
						cellVal:""
					},
					zzs_1_x_2:{
						cellVal:""
					},
					zzs_1_x_3:{
						cellVal:""
					},
					zzs_1_x_4:{
						cellVal:""
					},
					zzs_1_x_5:{
						cellVal:""
					},
					zzs_1_x_6:{
						cellVal:""
					},
					zzs_1_x_7:{
						cellVal:""
					},
					zzs_1_x_8:{
						cellVal:""
					},
					zzs_1_x_9:{
						cellVal:""
					},
					zzs_1_x_10:{
						cellVal:""
					},
					zzs_1_x_11:{
						cellVal:""
					},
					zzs_1_x_12:{
						cellVal:""
					},
					zzs_1_x_13:{
						cellVal:""
					},
					zzs_1_x_14:{
						cellVal:""
					},
				},
				{
					title:"二、简易计税方法计税",
					mintitle:"其中：即征即退项目",
					coloum:"即征即退货物及加工修理修配劳务",
					grade:"14",
					disabledzzs_1_x_1:true,
					disabledzzs_1_x_2:true,
					disabledzzs_1_x_3:true,
					disabledzzs_1_x_4:true,
					disabledzzs_1_x_5:true,
					disabledzzs_1_x_6:true,
					disabledzzs_1_x_7:true,
					disabledzzs_1_x_8:true,
					disabledzzs_1_x_11:true,//禁止合计价税合计
					disabledzzs_1_x_12:true,//禁止各类服务金额
					disabledzzs_1_x_13:true,
					disabledzzs_1_x_14:true,
					zzs_1_x_1:{
						cellVal:""
					},
					zzs_1_x_2:{
						cellVal:""
					},
					zzs_1_x_3:{
						cellVal:""
					},
					zzs_1_x_4:{
						cellVal:""
					},
					zzs_1_x_5:{
						cellVal:""
					},
					zzs_1_x_6:{
						cellVal:""
					},
					zzs_1_x_7:{
						cellVal:""
					},
					zzs_1_x_8:{
						cellVal:""
					},
					zzs_1_x_9:{
						cellVal:""
					},
					zzs_1_x_10:{
						cellVal:""
					},
					zzs_1_x_11:{
						cellVal:""
					},
					zzs_1_x_12:{
						cellVal:""
					},
					zzs_1_x_13:{
						cellVal:""
					},
					zzs_1_x_14:{
						cellVal:""
					},
				},
				{
					title:"二、简易计税方法计税",
					mintitle:"其中：即征即退项目",
					coloum:"即征即退服务、不动产和无形资产",
					grade:"15",
					disabledzzs_1_x_1:true,
					disabledzzs_1_x_2:true,
					disabledzzs_1_x_3:true,
					disabledzzs_1_x_4:true,
					disabledzzs_1_x_5:true,
					disabledzzs_1_x_6:true,
					disabledzzs_1_x_7:true,
					disabledzzs_1_x_8:true,
					disabledzzs_1_x_11:true,//禁止合计价税合计
					disabledzzs_1_x_12:true,//禁止各类服务金额
					disabledzzs_1_x_13:true,
					zzs_1_x_1:{
						cellVal:""
					},
					zzs_1_x_2:{
						cellVal:""
					},
					zzs_1_x_3:{
						cellVal:""
					},
					zzs_1_x_4:{
						cellVal:""
					},
					zzs_1_x_5:{
						cellVal:""
					},
					zzs_1_x_6:{
						cellVal:""
					},
					zzs_1_x_7:{
						cellVal:""
					},
					zzs_1_x_8:{
						cellVal:""
					},
					zzs_1_x_9:{
						cellVal:""
					},
					zzs_1_x_10:{
						cellVal:""
					},
					zzs_1_x_11:{
						cellVal:""
					},
					zzs_1_x_12:{
						cellVal:""
					},
					zzs_1_x_13:{
						cellVal:""
					},
					zzs_1_x_14:{
						cellVal:""
					},
				},
				{
					title:"三、免抵退税",
					mintitle:"货物及加工修理修配劳务",
					coloum:"",
					grade:"16",
					disabledzzs_1_x_1:true,
					disabledzzs_1_x_2:true,
					disabledzzs_1_x_4:true,
					disabledzzs_1_x_6:true,
					disabledzzs_1_x_7:true,
					disabledzzs_1_x_8:true,
					disabledzzs_1_x_9:true,//禁止合计销售额填写
					disabledzzs_1_x_10:true,//禁止合计销项（应纳）税额
					disabledzzs_1_x_11:true,//禁止合计价税合计
					disabledzzs_1_x_12:true,//禁止各类服务金额
					disabledzzs_1_x_13:true,
					disabledzzs_1_x_14:true,
					zzs_1_x_1:{
						cellVal:""
					},
					zzs_1_x_2:{
						cellVal:""
					},
					zzs_1_x_3:{
						cellVal:""
					},
					zzs_1_x_4:{
						cellVal:""
					},
					zzs_1_x_5:{
						cellVal:""
					},
					zzs_1_x_6:{
						cellVal:""
					},
					zzs_1_x_7:{
						cellVal:""
					},
					zzs_1_x_8:{
						cellVal:""
					},
					zzs_1_x_9:{
						cellVal:""
					},
					zzs_1_x_10:{
						cellVal:""
					},
					zzs_1_x_11:{
						cellVal:""
					},
					zzs_1_x_12:{
						cellVal:""
					},
					zzs_1_x_13:{
						cellVal:""
					},
					zzs_1_x_14:{
						cellVal:""
					},
				},
				{
					title:"三、免抵退税",
					mintitle:"服务、不动产和无形资产",
					coloum:"",
					grade:"17",
					disabledzzs_1_x_1:true,
					disabledzzs_1_x_2:true,
					disabledzzs_1_x_4:true,
					disabledzzs_1_x_6:true,
					disabledzzs_1_x_7:true,
					disabledzzs_1_x_8:true,
					disabledzzs_1_x_9:true,//禁止合计销售额填写
					disabledzzs_1_x_10:true,//禁止合计销项（应纳）税额
					disabledzzs_1_x_11:true,//禁止合计价税合计
					disabledzzs_1_x_12:true,//禁止各类服务金额
					disabledzzs_1_x_13:true,
					disabledzzs_1_x_14:true,
					zzs_1_x_1:{
						cellVal:""
					},
					zzs_1_x_2:{
						cellVal:""
					},
					zzs_1_x_3:{
						cellVal:""
					},
					zzs_1_x_4:{
						cellVal:""
					},
					zzs_1_x_5:{
						cellVal:""
					},
					zzs_1_x_6:{
						cellVal:""
					},
					zzs_1_x_7:{
						cellVal:""
					},
					zzs_1_x_8:{
						cellVal:""
					},
					zzs_1_x_9:{
						cellVal:""
					},
					zzs_1_x_10:{
						cellVal:""
					},
					zzs_1_x_11:{
						cellVal:""
					},
					zzs_1_x_12:{
						cellVal:""
					},
					zzs_1_x_13:{
						cellVal:""
					},
					zzs_1_x_14:{
						cellVal:""
					},
				},
				{
					title:"四、免税",
					mintitle:"货物及加工修理修配劳务",
					coloum:"",
					grade:"18",
					
					disabledzzs_1_x_4:true,
					disabledzzs_1_x_6:true,
					disabledzzs_1_x_7:true,
					disabledzzs_1_x_8:true,
					disabledzzs_1_x_9:true,//禁止合计销售额填写
					disabledzzs_1_x_10:true,//禁止合计销项（应纳）税额
					disabledzzs_1_x_11:true,//禁止合计价税合计
					disabledzzs_1_x_12:true,//禁止各类服务金额
					disabledzzs_1_x_13:true,
					disabledzzs_1_x_14:true,
					zzs_1_x_1:{
						cellVal:""
					},
					zzs_1_x_2:{
						cellVal:""
					},
					zzs_1_x_3:{
						cellVal:""
					},
					zzs_1_x_4:{
						cellVal:""
					},
					zzs_1_x_5:{
						cellVal:""
					},
					zzs_1_x_6:{
						cellVal:""
					},
					zzs_1_x_7:{
						cellVal:""
					},
					zzs_1_x_8:{
						cellVal:""
					},
					zzs_1_x_9:{
						cellVal:""
					},
					zzs_1_x_10:{
						cellVal:""
					},
					zzs_1_x_11:{
						cellVal:""
					},
					zzs_1_x_12:{
						cellVal:""
					},
					zzs_1_x_13:{
						cellVal:""
					},
					zzs_1_x_14:{
						cellVal:""
					},
				},
				{
					title:"四、免税",
					mintitle:"服务、不动产和无形资产",
					coloum:"",
					grade:"19",
					disabledzzs_1_x_1:true,
					disabledzzs_1_x_2:true,
					disabledzzs_1_x_4:true,
					disabledzzs_1_x_6:true,
					disabledzzs_1_x_7:true,
					disabledzzs_1_x_8:true,
					disabledzzs_1_x_9:true,//禁止合计销售额填写
					disabledzzs_1_x_10:true,//禁止合计销项（应纳）税额
					disabledzzs_1_x_11:true,//禁止合计价税合计
					disabledzzs_1_x_12:true,//禁止各类服务金额
					disabledzzs_1_x_13:true,
					disabledzzs_1_x_14:true,
					zzs_1_x_1:{
						cellVal:""
					},
					zzs_1_x_2:{
						cellVal:""
					},
					zzs_1_x_3:{
						cellVal:""
					},
					zzs_1_x_4:{
						cellVal:""
					},
					zzs_1_x_5:{
						cellVal:""
					},
					zzs_1_x_6:{
						cellVal:""
					},
					zzs_1_x_7:{
						cellVal:""
					},
					zzs_1_x_8:{
						cellVal:""
					},
					zzs_1_x_9:{
						cellVal:""
					},
					zzs_1_x_10:{
						cellVal:""
					},
					zzs_1_x_11:{
						cellVal:""
					},
					zzs_1_x_12:{
						cellVal:""
					},
					zzs_1_x_13:{
						cellVal:""
					},
					zzs_1_x_14:{
						cellVal:""
					},
				}
			]
		
	}
	return obj
}
